import { Component, Suspense, lazy } from "react";
import { ArrowRight, Phone } from "lucide-react";
import { DEFAULT_CONTENT } from "@/constants/siteDefaults";

const Glass3D = lazy(() => import("./Glass3D"));

class Boundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    return this.state.failed ? null : this.props.children;
  }
}

export default function Hero({ content }) {
  const eyebrow = content?.hero_eyebrow || DEFAULT_CONTENT.hero_eyebrow;
  const heading = content?.hero_heading || DEFAULT_CONTENT.hero_heading;
  const subtitle = content?.hero_subtitle || DEFAULT_CONTENT.hero_subtitle;
  return (
    <section id="top" className="relative min-h-[92vh] flex items-center overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 opacity-80">
        <Boundary>
          <Suspense fallback={null}>
            <Glass3D />
          </Suspense>
        </Boundary>
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#FDFDFD] via-[#FDFDFD]/85 to-transparent pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-32 w-full">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-6 animate-fade-up" data-testid="hero-eyebrow">
          {eyebrow}
        </p>
        <h1
          className="font-outfit text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light text-slate-900 max-w-3xl animate-fade-up"
          style={{ animationDelay: "0.1s" }}
          data-testid="hero-heading"
        >
          {heading}
        </h1>
        <p
          className="mt-6 text-base md:text-lg leading-relaxed text-slate-600 max-w-xl animate-fade-up"
          style={{ animationDelay: "0.2s" }}
          data-testid="hero-subtitle"
        >
          {subtitle}
        </p>
        <div className="mt-10 flex flex-wrap gap-4 animate-fade-up" style={{ animationDelay: "0.3s" }}>
          <a
            href="#contact"
            data-testid="hero-enquire-button"
            className="inline-flex items-center gap-2 bg-slate-900 text-white px-7 py-3.5 rounded-sm font-medium hover:bg-sky-500 hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
          >
            Enquire Now <ArrowRight size={16} />
          </a>
          <a
            href="tel:+61404179886"
            data-testid="hero-call-button"
            className="inline-flex items-center gap-2 border border-slate-900 text-slate-900 px-7 py-3.5 rounded-sm font-medium hover:bg-slate-900 hover:text-white hover:-translate-y-0.5 transition-[background-color,color,transform] duration-300"
          >
            <Phone size={16} /> Call 0404 179 886
          </a>
        </div>
      </div>
    </section>
  );
}
